import script from "./Dob.vue?vue&type=script&setup=true&lang=js"
export * from "./Dob.vue?vue&type=script&setup=true&lang=js"

import "./Dob.vue?vue&type=style&index=0&id=55b3acaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55b3acaa"]])

export default __exports__